import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'
import { toast } from 'sonner'
import { api } from '../lib/api'
import { Field } from '../components/ui/Field'
import { Button } from '../components/ui/Button'

const Schema = z.object({
  email: z.string().email('Email invalid'),
})

type Input = z.infer<typeof Schema>

export function ForgotPasswordPage() {
  const [submitted, setSubmitted] = useState(false)
  const [submitting, setSubmitting] = useState(false)

  const form = useForm<Input>({
    resolver: zodResolver(Schema),
    defaultValues: { email: '' },
  })

  const onSubmit = async (data: Input) => {
    setSubmitting(true)
    try {
      await api.post('/auth/forgot-password', data)
      setSubmitted(true)
    } catch (err: unknown) {
      const message =
        (err as { response?: { data?: { error?: { message?: string } } } })?.response?.data?.error
          ?.message ?? 'Eroare. Reîncearcă sau contactează un administrator.'
      toast.error(message)
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <div className="flex h-screen items-center justify-center bg-b4l-bg">
      <div className="w-full max-w-sm rounded-lg border border-b4l-border bg-white p-8 shadow-sm">
        <h1 className="mb-1 text-xl font-semibold text-b4l-green-dark">Resetare parolă</h1>
        <p className="mb-6 text-sm text-b4l-text-muted">
          Introdu adresa de e-mail a contului — îți trimitem un link de resetare valabil o oră.
        </p>

        {submitted ? (
          <div className="space-y-3">
            <div className="rounded border border-b4l-green-light bg-b4l-green-light p-3 text-sm text-b4l-green-dark">
              Dacă adresa există în sistem, am trimis un link de resetare. Verifică și folderul
              Spam. Linkul este valabil o oră.
            </div>
            <Link
              to="/login"
              className="block text-center text-sm text-b4l-green-dark hover:underline"
            >
              Înapoi la autentificare
            </Link>
          </div>
        ) : (
          <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4" noValidate>
            <Field
              label="Email"
              type="email"
              autoFocus
              autoComplete="email"
              {...form.register('email')}
              error={form.formState.errors.email?.message}
            />
            <Button type="submit" loading={submitting} className="w-full">
              Trimite link de resetare
            </Button>
            <Link
              to="/login"
              className="block text-center text-xs text-b4l-text-muted hover:text-b4l-text"
            >
              Înapoi la autentificare
            </Link>
          </form>
        )}
      </div>
    </div>
  )
}
